import React from "react";
import {
  array,
  arrayOf,
  bool,
  func,
  number,
  obj,
  shape,
  string
} from "prop-types";

import NeighborhoodWithCheckbox from "../NeighborhoodWithCheckbox";
import * as S from "./styled";

const BoroughTab = ({
  area,
  isChecked,
  isHovered,
  onCheck,
  onClick,
  onHover,
  selected
}) => (
  <S.BoroughTab onClick={onClick} onKeyDown={onClick} role="presentation">
    <NeighborhoodWithCheckbox
      isChecked={isChecked}
      isHovered={isHovered}
      isTitle
      neighborhood={area}
      onCheck={onCheck}
      onHover={onHover}
      showCheckBox={selected}
    />
  </S.BoroughTab>
);

BoroughTab.propTypes = {
  area: shape({
    descendents: arrayOf(
      shape({
        id: number
      })
    ),
    children: array,
    decodedCoordinates: array,
    id: number,
    level: number,
    map_coordinates: obj,
    name: string,
    parent: obj
  }).isRequired,
  onCheck: func.isRequired,
  onHover: func.isRequired,
  onClick: func.isRequired,
  isChecked: bool,
  isHovered: bool,
  selected: bool
};

BoroughTab.defaultProps = {
  isChecked: false,
  isHovered: false,
  selected: false
};

export default BoroughTab;
